import React from 'react';
export function PainPoints() {
  const points = ['Domingo buscando ejercicios en YouTube que nunca quedan bien para tu grupo real', 'Planificaciones armadas la noche anterior, a las corridas, sin progresión real', 'Siempre las mismas rutinas porque no tenés un banco de clases serio', 'La potencia, el CORE, la hipertrofia — sin sistema progresivo ni criterio', 'Grupos con distintos niveles juntos sin material diferenciado — perdés a todos', 'Fin de semana agotado, el domingo volvés a empezar el mismo ciclo'];
  return <section className="py-16 px-4 bg-surface/30 border-y border-zinc-800" data-id="element-222">
      <div className="max-w-3xl mx-auto" data-id="element-223">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-224">
          ¿Cuántos domingos más vas a perder así?
        </h2>

        <div className="text-lg text-zinc-300 space-y-4 mb-10 text-center" data-id="element-225">
          <p data-id="element-226">
            Sos profe de entrenamiento funcional. Amás lo que hacés. Pero nadie
            te dijo que ibas a pasar los domingos buscando ejercicios que no
            encajan, armando clases a la noche y llegando al lunes con una
            rutina que "más o menos sirve".
          </p>
          <p className="font-bold text-white" data-id="element-227">
            No es falta de vocación. Es falta de un sistema.
          </p>
        </div>

        <div className="space-y-4 mb-12" data-id="element-228">
          {points.map((point, i) => <div key={i} className="flex items-start gap-3 bg-surface p-4 rounded-xl border border-zinc-800/50" data-id="element-229">
              <span className="text-red-500 mt-0.5" data-id="element-230">❌</span>
              <span className="text-zinc-300" data-id="element-231">{point}</span>
            </div>)}
        </div>

        <div className="text-center" data-id="element-232">
          <h3 className="text-2xl md:text-3xl font-bold text-primary" data-id="element-233">
            ¿Y si este fuera el último domingo que pasás así?
          </h3>
        </div>
      </div>
    </section>;
}